import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import QuantityEditModal from "./QuantityEditModal";

export default function CartItemQuantity({
  disabled,
  value,
  onChange,
  availableQuantity,
  inputProps = {},
  minQuantity = 0,
  quantityLabel,
  centerValue = false,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <TextField
        disabled={disabled}
        value={value}
        size="small"
        onClick={!disabled ? handleOpenModal : undefined}
        sx={{
          maxWidth: 110,
          "& .MuiInputBase-input": {
            cursor: disabled ? "default" : "pointer",
            textAlign: centerValue ? "center" : undefined,
          },
        }}
        inputProps={{
          readOnly: true,
          "aria-label": "Edit quantity",
          ...inputProps?.inputProps,
        }}
        InputProps={{
          readOnly: true,
          endAdornment: !disabled && (
            <InputAdornment position="end">
              <Tooltip title="Edit Quantity" placement="top">
                <IconButton onClick={handleOpenModal} size="small" edge="end">
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ),
        }}
        {...inputProps}
      />
      {isModalOpen && (
        <QuantityEditModal
          onClose={handleCloseModal}
          value={value}
          onChange={onChange}
          availableQuantity={availableQuantity}
          minQuantity={minQuantity}
          quantityLabel={quantityLabel}
        />
      )}
    </>
  );
}
